import reducer from './reducers';
import type { History } from 'history';
import type { State } from './reducers';
import { configureStore } from '@reduxjs/toolkit';
import { routerMiddleware } from 'connected-react-router';
import Cookies from 'js-cookie';

// Note: ts error regarding non-portable type is fine since this is only used within the ZRM app
export default function createStore(preloadedState: Partial<State> | undefined, history: History) {
  return configureStore({
    devTools: __DEV__ || Cookies.getJSON('ZRM_REDUX_DEVTOOLS') === true,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ serializableCheck: false }).concat(routerMiddleware(history)),
    preloadedState,
    reducer: reducer(history),
  });
}

type Store = ReturnType<typeof createStore>;
export type AppDispatch = Store['dispatch'];
